import { type Images } from '@neos/app'

const images: Images = {
}

export default images